import { makeStyles } from "@material-ui/core";

export const useResetPasswordSuccessStyles = makeStyles(() => ({
    infoWrapper: {
        margin: "7px 0px"
    },
    footer: {
        paddingTop: 36
    }
}));
